import { ReactNode } from 'react';
import { CardHeader, Card, CardBody, DataTable } from '@blockanalitica/ui';
import {
  TableProps,
  TableData
} from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

interface CardTableProps<T> extends TableProps<T> {
  title?: ReactNode;
}

export default function CardTable<RowType = TableData>({
  title,
  ...rest
}: CardTableProps<RowType>) {
  return (
    <Card variant="table">
      {title ? <CardHeader title={<>{title}</>} /> : null}
      <CardBody variant="table">
        <DataTable<RowType> {...rest} />
      </CardBody>
    </Card>
  );
}
